import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

/**
 * Redirect any path containing uppercase characters to its lowercase form,
 * preserving query string + hash. Ports the old Next.js middleware behavior
 * (which only lowercased url.pathname) to the client router.
 *
 * Render once inside <BrowserRouter>, above <Routes>.
 */
export default function LowercasePathRedirect() {
  const { pathname, search, hash } = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    const lower = pathname.toLowerCase()
    if (lower !== pathname) {
      navigate(`${lower}${search}${hash}`, { replace: true })
    }
  }, [pathname, search, hash, navigate])

  return null
}
